import {MainException} from 'common/exception/MainException';
import {ExceptionContract} from 'common/exception/ExceptionContract';

export class PageNotFoundException extends MainException implements ExceptionContract {
    public constructor(message: string, data?: {[key: string]: any}) {
        super(message, 404, data);
        this.name = 'PageNotFoundException';
    }
}
